export default __webpack_public_path__ + "static/media/emirates.bdf69f5b.svg";